module.exports = __webpack_public_path__ + "img/1518497081.a53183c5.jpg";